import { useState, useEffect } from 'react';
import { api } from '../api';

function fullName(t) { return t ? `${t.firstName || ''} ${t.lastName || ''}`.trim() : ''; }
function className(c) { return c ? `${c.name} - ${c.section}` : '—'; }

export default function ClassAssignment() {
  const [assignments, setAssignments] = useState([]);
  const [classes, setClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ classSection: { id: '' }, teacher: { id: '' }, subject: { id: '' } });
  const [err, setErr] = useState('');
  const [filterClass, setFilterClass] = useState('');

  useEffect(() => {
    Promise.all([
      api.getAssignments(),
      api.getClasses(),
      api.getTeachers(),
      api.getSubjects()
    ]).then(([a, c, t, s]) => {
      setAssignments(a); setClasses(c); setTeachers(t); setSubjects(s);
    }).catch(() => setErr('Failed to load data'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = assignments.filter(a =>
    !filterClass || a.classSection?.id === parseInt(filterClass)
  );

  const handleSave = async () => {
    if (!form.classSection.id || !form.teacher.id || !form.subject.id) {
      setErr('All fields are required'); return;
    }
    try {
      await api.createAssignment({
        classSection: { id: parseInt(form.classSection.id) },
        teacher: { id: parseInt(form.teacher.id) },
        subject: { id: parseInt(form.subject.id) }
      });
      window.location.reload();
    } catch (e) { setErr(e.message); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this assignment?')) return;
    await api.deleteAssignment(id);
    window.location.reload();
  };

  if (loading) return <div className="loading-msg">Loading assignments…</div>;

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <div className="card-title">Assign Teacher to Class &amp; Subject</div>
        </div>
        <div className="card-body">
          {err && <div className="error-msg">{err}</div>}
          <div className="form-grid cols-3">
            <div className="form-group">
              <label className="form-label">Class</label>
              <select className="form-control" value={form.classSection.id}
                onChange={e => setForm(f => ({ ...f, classSection: { id: e.target.value } }))}>
                <option value="">-- Select Class --</option>
                {classes.map(c => <option key={c.id} value={c.id}>{className(c)}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Teacher</label>
              <select className="form-control" value={form.teacher.id}
                onChange={e => setForm(f => ({ ...f, teacher: { id: e.target.value } }))}>
                <option value="">-- Select Teacher --</option>
                {teachers.map(t => <option key={t.id} value={t.id}>{fullName(t)}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Subject</label>
              <select className="form-control" value={form.subject.id}
                onChange={e => setForm(f => ({ ...f, subject: { id: e.target.value } }))}>
                <option value="">-- Select Subject --</option>
                {subjects.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
          </div>
          <div className="form-actions">
            <button className="btn btn-primary" onClick={handleSave}>
              <i className="fas fa-link"></i> Assign
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div>
            <div className="card-title">Current Assignments</div>
            <div className="card-subtitle">{filtered.length} assignments</div>
          </div>
          <div className="card-actions">
            <select className="form-control" style={{ width: 160 }} value={filterClass} onChange={e => setFilterClass(e.target.value)}>
              <option value="">All Classes</option>
              {classes.map(c => <option key={c.id} value={c.id}>{className(c)}</option>)}
            </select>
          </div>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>#</th><th>Class</th><th>Subject</th><th>Teacher</th><th>Action</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: '#888', padding: 30 }}>No assignments found</td></tr>
              )}
              {filtered.map((a, i) => (
                <tr key={a.id}>
                  <td>{i + 1}</td>
                  <td>{a.classSection ? className(a.classSection) : '—'}</td>
                  <td>{a.subject?.name}</td>
                  <td>{fullName(a.teacher)}</td>
                  <td>
                    <button className="btn btn-danger btn-sm btn-icon" onClick={() => handleDelete(a.id)} title="Remove">
                      <i className="fas fa-unlink"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
